import React from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../services/api';
import { Card } from 'react-bootstrap';


const InformacoesDocumento: React.FC = () => {
    const [trabalhador, setTrabalhador] = React.useState<any>();
    const [empresa, setEmpresa] = React.useState<any>();
    const [reaproveitamento, setReaproveitamento] = React.useState<any>();
    const { idEmpresa, idTrabalhador, idDoc } = useParams();

    const fetchInformacoesDocumento = async () => {
        try {
            const response = await api.get(`/buscar-informacoes-documento/empresa/${idEmpresa}/trabalhador/${idTrabalhador}/reap/${idDoc}`);
            const { trabalhador, empresa, reaproveitamento } = response.data;
            setTrabalhador(trabalhador);
            setEmpresa(empresa);
            setReaproveitamento(reaproveitamento);
        } catch (error) {
            console.error(error);
        }
        
    };

    React.useEffect(() => {
        fetchInformacoesDocumento();
    }, []);
    
    return (
        <>
        <div className="background background-vi-desktop background-mobile">
            <div className="container" style={{ maxWidth: "720px", padding: "20px" }}>
            <Card className="my-4 shadow-sm border-0" style={{ borderRadius: "8px" }}>
                <Card.Body
                className="card-body-vi-desktop card-body-mobile"
                style={{
                    padding: "30px",
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                }}
                >
                <Card.Title className="text-center mb-4">
                    <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>
                    Informações do Documento
                    </h1>
                </Card.Title>

                <hr />

                <h3 className="mb-3" style={{ fontSize: "18px", color: "#555" }}>
                    Trabalhador
                </h3>
                <p>
                    <strong>Nome:</strong> {trabalhador?.nome}
                </p>
                <p>
                    <strong>Sexo:</strong>{" "}
                    {trabalhador?.sexo === "M"
                    ? "MASCULINO"
                    : trabalhador?.sexo === "F"
                    ? "FEMININO"
                    : "Não informado"}
                </p>
                <p>
                    <strong>CPF:</strong> {trabalhador?.cpf}
                </p>
                <p>
                    <strong>RG:</strong> {trabalhador?.rg}
                </p>
                <p>
                    <strong>Data de Nascimento:</strong>{" "}
                    {trabalhador?.data_nascimento
                    ? new Date(trabalhador.data_nascimento).toLocaleDateString(
                        "pt-BR"
                        )
                    : ""}
                    &nbsp;|&nbsp;
                    <strong>Idade:</strong>{" "}
                    {trabalhador?.data_nascimento
                    ? Math.floor(
                        (new Date().getTime() -
                            new Date(trabalhador.data_nascimento).getTime()) /
                            (1000 * 60 * 60 * 24 * 365.25)
                        )
                    : ""}
                </p>
                <p>
                    <strong>Função:</strong> {reaproveitamento?.funcao.nome}
                </p>
                <br></br>
                <p>
                    <strong>GHE (Setor):</strong>{" "}
                    {reaproveitamento?.ghe ? reaproveitamento.ghe : "Não Adicionado"}
                </p>
                <p>
                    <strong>Frente de Trabalho:</strong>{" "}
                    {reaproveitamento?.frente_de_trabalho
                    ? reaproveitamento.frente_de_trabalho
                    : "Não adicionada"}
                </p>

                <hr />

                <h3 className="mb-3" style={{ fontSize: "18px", color: "#555" }}>
                    Empresa
                </h3>
                <p>
                    <strong>Nome:</strong> {empresa?.nome}
                </p>
                <p>
                    <strong>Endereço:</strong> {empresa?.endereco}, {empresa?.bairro},{" "}
                    {empresa?.cidade} - {empresa?.estado}
                </p>
                <p>
                    <strong>Ramo de Atividade:</strong> {empresa?.cnae}
                </p>
                <p>
                    <strong>Grau de Risco:</strong>{" "}
                    {empresa?.grau_risco ? empresa?.grau_risco : "Não informado"}
                </p>
                </Card.Body>
            </Card>
            </div>
        </div>
        </>
    );
};

export default InformacoesDocumento;